"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Attachment = void 0;
const react_1 = __importDefault(require("react"));
const Button_1 = require("../Button/Button");
const Icon_1 = require("../Icon/Icon");
const Flex_1 = require("../Layout/Flexbox/Flex");
const Item_1 = require("../Layout/Flexbox/Item");
const Link_1 = require("../Link/Link");
const Text_1 = require("../Text/Text");
const Attachment_styles_1 = require("./Attachment.styles");
const Attachment_types_1 = require("./Attachment.types");
const FILE_UPLOADING = "File uploading";
const UNKNOWN_FILENAME = "Unknown filename";
const isDocument = (fileType) => {
    return fileType.includes("pdf") || fileType.includes("doc");
};
const Attachment = ({ attachment, status, onRemove, index = 1, }) => {
    const AttachmentIcon = () => {
        switch (status) {
            case Attachment_types_1.Status.Loading:
                return (react_1.default.createElement(Attachment_styles_1.StyledThumbnailIcon, { status: status },
                    react_1.default.createElement(Attachment_styles_1.StyledSpinner, null)));
            case Attachment_types_1.Status.Error:
                return (react_1.default.createElement(Attachment_styles_1.StyledThumbnailIcon, { status: status },
                    react_1.default.createElement(Icon_1.Icon, { name: "Warning", colour: "red" })));
            case Attachment_types_1.Status.Success:
                if (attachment && isDocument(attachment.fileType)) {
                    return (react_1.default.createElement(Attachment_styles_1.StyledThumbnailIcon, null,
                        react_1.default.createElement(Icon_1.Icon, { name: "Document" })));
                }
                if (attachment === null || attachment === void 0 ? void 0 : attachment.previewUrl) {
                    return (react_1.default.createElement(Attachment_styles_1.StyledThumbnailImage, { alt: "Thumbnail of attached file", src: attachment.previewUrl }));
                }
                return (react_1.default.createElement(Attachment_styles_1.StyledThumbnailIcon, null,
                    react_1.default.createElement(Icon_1.Icon, { name: "Photo" })));
        }
    };
    const AttachmentTitle = () => {
        if (status === Attachment_types_1.Status.Loading) {
            return react_1.default.createElement(Text_1.Text, { skinny: true }, FILE_UPLOADING);
        }
        if (attachment.fileName && (attachment === null || attachment === void 0 ? void 0 : attachment.previewUrl)) {
            return (react_1.default.createElement(Link_1.Link, { href: attachment.previewUrl, openInNewTab: true },
                react_1.default.createElement(Link_1.Link.Text, { text: attachment.fileName }),
                react_1.default.createElement(Link_1.Link.Icon, { openInNewTab: true })));
        }
        if (attachment.fileName) {
            return react_1.default.createElement(Text_1.Text, { skinny: true }, attachment.fileName);
        }
        return react_1.default.createElement(Text_1.Text, { skinny: true }, UNKNOWN_FILENAME);
    };
    const AttachmentAction = () => {
        const { attachmentId } = attachment; // Required destructuring for typing below
        if (!attachmentId) {
            return react_1.default.createElement(react_1.default.Fragment, null);
        }
        return (react_1.default.createElement(Button_1.Button, { theme: "secondary", icon: {
                name: "Cross",
                colour: "red",
                title: `Delete attachment ${index}`,
            }, onClick: () => onRemove({ attachmentId }) }));
    };
    const AttachmentInfo = () => {
        return attachment.fileSize ? (react_1.default.createElement(Text_1.Text, { skinny: true },
            (attachment.fileSize / (1024 * 1024)).toPrecision(2),
            " MB")) : (react_1.default.createElement(react_1.default.Fragment, null));
    };
    const AttachmentErrors = () => {
        return (react_1.default.createElement(react_1.default.Fragment, null, attachment.errors.map((error) => (react_1.default.createElement(Text_1.Text, { skinny: true, colour: "red", key: error }, error)))));
    };
    return (react_1.default.createElement(Attachment_styles_1.StyledFileRow, null,
        react_1.default.createElement(Flex_1.Flex, null,
            react_1.default.createElement(Item_1.Item, null,
                react_1.default.createElement(AttachmentIcon, null)),
            react_1.default.createElement(Item_1.Item, null,
                react_1.default.createElement(AttachmentTitle, null),
                react_1.default.createElement(AttachmentInfo, null),
                react_1.default.createElement(AttachmentErrors, null))),
        react_1.default.createElement(AttachmentAction, null)));
};
exports.Attachment = Attachment;
//# sourceMappingURL=Attachment.js.map